/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceQueryTagKey extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceQueryTagKey");
    }

    getFixupPrototypeFunction() { return ResourceQueryTagKey.fixupPrototype; }

    static newInstance(model: Partial<ResourceQueryTagKey>): ResourceQueryTagKey {
        let obj = Object.assign(new ResourceQueryTagKey(), model);
        ResourceQueryTagKey.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceQueryTagKey>): ResourceQueryTagKey {
        if (!model) return null;
        return ResourceQueryTagKey.newInstance(<ResourceQueryTagKey> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceQueryTagKey) {
        if (!obj) return;

        models.ResourceQueryTagKey.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceQueryTagKey): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceQueryTagKey.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tag key for the given resources
     */
    tag_keys: Array<string>;

    /**
     * Tag kind if applicable
     */
    tag_kind: string;

}
